// Intelligence Notebook module availability. Default ON — the Notebook is part
// of the admin experience (appears under Planning) by default; no opt-in env var
// or localStorage key is required. An explicit opt-OUT is still honored for an
// emergency disable: REACT_APP_INTELLIGENCE_NOTEBOOK='false' at build time, or
// per-browser localStorage 'intelligence_notebook_enabled'='0'. Anything else → ON.
export function isIntelligenceNotebookEnabled() {
  try {
    const env = process.env.REACT_APP_INTELLIGENCE_NOTEBOOK;
    if (env === 'false') return false;   // explicit build-time opt-out
    if (env === 'true') return true;
    if (typeof window !== 'undefined' && window.localStorage
        && window.localStorage.getItem('intelligence_notebook_enabled') === '0') {
      return false;                       // explicit per-browser opt-out
    }
  } catch (e) { /* ignore */ }
  return true;                            // ON by default
}
